const keySuffix = 'I18n'

const translateObject = (obj, t) => {
    const keys = Object.keys(obj)
    keys.forEach((key) => {
        if (key.endsWith(keySuffix)) {
            const translationKey = key.slice(0, -4)
            obj[translationKey] = t(obj[key])
        }
    })
}

const translateObjectDeep = (obj, t) => {
    const keys = Object.keys(obj)
    keys.forEach((key) => {
        if (key.endsWith(keySuffix)) {
            const translationKey = key.slice(0, -4)
            obj[translationKey] = t(obj[key])
        } else if (obj[key] !== null && typeof obj[key] === 'object') {
            translateObjectDeep(obj[key], t)
        }
    })
}

export { translateObject, translateObjectDeep }
